import { render, staticRenderFns } from "./gc-field-select.vue?vue&type=template&id=28f6a7d4&scoped=true&"
import script from "./gc-field-select.vue?vue&type=script&lang=js&"
export * from "./gc-field-select.vue?vue&type=script&lang=js&"
import style0 from "./gc-field-select.vue?vue&type=style&index=0&id=28f6a7d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f6a7d4",
  null
  
)

export default component.exports